import React, { useState } from "react";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import AppSetting from "./AppSetting";
import PaymentSetting from "./PaymentSetting";
import PaymentGatewaySetting from "./PaymentGatewaySetting";
import MonetizationSetting from "./MonetizationSetting";

const ManageSetting = () => {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Setting");

  return (
    <div className="userPage">
      <PageHeader heading={"Welcome Admin"} subHeading={"Setting"} />

      <MultiButton
        label={[
          "Setting",
          "Payment Setting",
          "Monetize & Ads Setting",
          "Withdraw Setting",
        ]}
        setMultiButtonSelect={setMultiButtonSelect}
        multiButtonSelect={multiButtonSelect}
      />

      {multiButtonSelect == "Setting" && (
        <AppSetting multiButtonSelectNavigate={setMultiButtonSelect} />
      )}
      {multiButtonSelect == "Payment Setting" && <PaymentSetting />}
      {multiButtonSelect == "Withdraw Setting" && <PaymentGatewaySetting />}
      {multiButtonSelect == "Monetize & Ads Setting" && <MonetizationSetting />}
    </div>
  );
};

export default ManageSetting;
